import { AxiosError } from 'axios'
import { TFunction } from 'i18next'

const DEFAULT_RECOVERY_URL_BASE = 'https://cdn.id.global.vtv.vodafone.com/bootstrap'
const GENERIC_ERROR = 'error_messages.VIPOC_ERROR_004'

export function backendErrorMessage(error: unknown) {
  const data = (error as AxiosError)?.response?.data as any
  const message = typeof data === 'string' ? data : data?.message

  return message?.trim() || GENERIC_ERROR
}

export function translate(t: TFunction, key: string) {
  return t(key)
}

export function formatBytesAsGigabytes(bytes: number) {
  const gigabytes = bytes / 1024 / 1024 / 1024
  const rounded = Math.round(gigabytes * 10) / 10
  return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded}GB`
}

export function isAcceptedBuildFile(fileName: string) {
  const normalizedName = fileName.toLowerCase()
  return normalizedName.endsWith('.zip') || normalizedName.endsWith('.bin')
}

export function buildRecoveryUrl(
  version: string,
  platform: string,
  buildName: string,
  currentRecoveryUrl?: string
) {
  const recoveryUrl = currentRecoveryUrl?.trim()
  const bootstrapIndex = recoveryUrl?.indexOf('/bootstrap') ?? -1
  const base =
    bootstrapIndex > 0
      ? recoveryUrl!.slice(0, bootstrapIndex + '/bootstrap'.length)
      : DEFAULT_RECOVERY_URL_BASE

  return `${base}/${version}/${platform}/release/${buildName}`
}
